<template>
  <aside v-if="toggleEnabled" class="price-visibility-toggle" aria-label="Price display tester">
    <span class="price-visibility-toggle__label">Test prices</span>
    <button
      type="button"
      class="price-visibility-toggle__button"
      :class="{ 'is-on': showPrices }"
      role="switch"
      :aria-checked="String(showPrices)"
      @click="togglePrices"
    >
      <span class="price-visibility-toggle__track"><span></span></span>
      {{ showPrices ? 'Shown' : 'Hidden' }}
    </button>
  </aside>
</template>

<script>
import { SHOW_PRICES, SHOW_PRICE_TOGGLE } from '../config'

export default {
  name: 'PriceVisibilityToggle',
  data(){
    return {
      showPrices: SHOW_PRICES,
      toggleEnabled: SHOW_PRICE_TOGGLE
    }
  },
  methods: {
    togglePrices(){
      window.localStorage.setItem('gixcore_show_prices_override', String(!this.showPrices))
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.price-visibility-toggle {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid rgba(74, 82, 103, 0.9);
  border-radius: 8px;
  background: rgba(8, 11, 17, 0.94);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.38);
  color: #9198aa;
  font-size: 11px;
  backdrop-filter: blur(10px);
}
.price-visibility-toggle__label { font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; }
.price-visibility-toggle__button { display: inline-flex; align-items: center; gap: 6px; padding: 0; border: 0; background: transparent; color: #cfd2da; font: inherit; font-weight: 700; cursor: pointer; }
.price-visibility-toggle__track { position: relative; width: 30px; height: 16px; border-radius: 999px; background: #343a49; transition: background 0.18s ease; }
.price-visibility-toggle__track span { position: absolute; top: 2px; left: 2px; width: 12px; height: 12px; border-radius: 50%; background: #cfd2da; transition: transform 0.18s ease; }
.price-visibility-toggle__button.is-on { color: #78e3c3; }
.price-visibility-toggle__button.is-on .price-visibility-toggle__track { background: #008f70; }
.price-visibility-toggle__button.is-on .price-visibility-toggle__track span { transform: translateX(14px); }
</style>
